import { FIELDS } from './constants';

const defaultFields = [
  {
    key: 'ExpenseAccountName',
    field: FIELDS.EXPENSE_ACCOUNT_NAME,
    title: ' Expense Account Name',
    label: 'ExpenseAccountName',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    // width: 150,
  },
  {
    key: 'ExpenseDate',
    field: FIELDS.EXPENSE_DATE,
    title: ' Expense Date',
    label: 'ExpenseDate',
    cell: 'formatDate',
    sortable: true,
    hidden: true,
    // width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    //width: 150,
  },
  {
    key: 'Amount',
    field: FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatAmountConverted',
    sortable: true,
    hidden: false,
    //width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    // headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
